"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Router = void 0;
var crossroads = require("expose-loader?exposes=crossroads!crossroads");
var queryString = require('query-string');
require('imports-loader?require=>false!vendors/history.js/scripts/bundled/html4+html5/native.history.js');
var slides_page_1 = require("./pages/slides-page");
var product_search_page_1 = require("./pages/product-search-page");
var product_detail_page_1 = require("./pages/product-detail-page");
var categories_menu_1 = require("./categories-menu");
var bookmarked_products_page_1 = require("./pages/bookmarked-products-page");
var InsightsCustomProperties_1 = require("./models/InsightsCustomProperties");
var routes_1 = require("./constants/routes");
var Router = /** @class */ (function () {
    function Router() {
    }
    Router.loadRouter = function () {
        crossroads.addRoute(window.BaseUrl + '/{id}/{DataVersion}:?query:', function (memberNrEncrypted, dataVersion) {
            var insightsCustomProperties = new InsightsCustomProperties_1.InsightsCustomProperties();
            insightsCustomProperties.section = routes_1.Routes.slides;
            Router.commonInit(insightsCustomProperties);
            categories_menu_1.CategoriesMenu.init(null);
            slides_page_1.SlidesPage.init(memberNrEncrypted, Router.ServerContentLoaded);
        });
        crossroads.addRoute(window.BaseUrl + '/{id}/{DataVersion}/ProductSearch/{categoryId}:?query:', function (memberNrEncrypted, dataVersion, categoryId, query) {
            var insightsCustomProperties = new InsightsCustomProperties_1.InsightsCustomProperties();
            insightsCustomProperties.section = routes_1.Routes.productSearch;
            insightsCustomProperties.categoryId = categoryId;
            insightsCustomProperties.query = queryString.stringify(query);
            Router.commonInit(insightsCustomProperties);
            categories_menu_1.CategoriesMenu.init(categoryId);
            product_search_page_1.ProductSearchPage.init(memberNrEncrypted, categoryId, query, Router.ServerContentLoaded);
        });
        crossroads.addRoute(window.BaseUrl + '/{id}/{DataVersion}/BookMarkedProducts:?query:', function (memberNrEncrypted, dataVersion) {
            var insightsCustomProperties = new InsightsCustomProperties_1.InsightsCustomProperties();
            insightsCustomProperties.section = routes_1.Routes.bookMarkedProducts;
            Router.commonInit(insightsCustomProperties);
            categories_menu_1.CategoriesMenu.init(null);
            bookmarked_products_page_1.BookMarkedProducts.init(memberNrEncrypted);
        });
        crossroads.addRoute(window.BaseUrl + '/{id}/{DataVersion}/ProductDetail/{articleNr}:?query:', function (memberNrEncrypted, dataVersion, articleNr) {
            var insightsCustomProperties = new InsightsCustomProperties_1.InsightsCustomProperties();
            insightsCustomProperties.articleNr = articleNr;
            insightsCustomProperties.section = routes_1.Routes.productDetail;
            Router.commonInit(insightsCustomProperties);
            product_detail_page_1.ProductDetailPage.init(memberNrEncrypted, articleNr, Router.ServerContentLoaded);
        });
        crossroads.addRoute(window.BaseUrl + '/Test/ProductDetail/{articleNr}:?query:', function (articleNr) {
            var insightsCustomProperties = new InsightsCustomProperties_1.InsightsCustomProperties();
            insightsCustomProperties.articleNr = articleNr;
            insightsCustomProperties.section = routes_1.Routes.productDetailTest;
            Router.commonInit(insightsCustomProperties);
            product_detail_page_1.ProductDetailPage.init(null, articleNr, Router.ServerContentLoaded);
        });
        crossroads.addRoute(window.BaseUrl + '/{id}/{DataVersion}/ProductDatasheet/{articleNr}:?query:', function (memberNrEncrypted, dataVersion, articleNr) {
            var insightsCustomProperties = new InsightsCustomProperties_1.InsightsCustomProperties();
            insightsCustomProperties.articleNr = articleNr;
            insightsCustomProperties.section = routes_1.Routes.productDetail;
            Router.commonInit(insightsCustomProperties);
            product_detail_page_1.ProductDetailPage.init(memberNrEncrypted, articleNr, Router.ServerContentLoaded);
        });
        //Content update and back/ forward button handler
        $(function () {
            //state change event: browsers compatible with history api
            History.Adapter.bind(window, 'statechange', function () {
                //trigger crossroads
                if (location.hash.length > 0) {
                    var state = History.getState();
                    var baseUrlRouter = window.BaseUrlWithVersions.concat("/");
                    var urlaction = state.hash.replace(baseUrlRouter, "").replace("./", "").replace("?&", "?") + document.location.search;
                    var finalUrl = baseUrlRouter.concat(urlaction).replace("//", "/");
                    crossroads.parse(finalUrl);
                }
                else {
                    crossroads.parse(document.location.pathname + document.location.search);
                }
            });
            //-----------------------------------------
            $(document).off("click.routerNavigation");
            $(document).on("click.routerNavigation", "a:not(.excludedEvent,.page-link)", Router.clickHandler);
            //Process the landing route
            History.pushState({}, document.location.pathname, document.location.pathname + document.location.search);
            crossroads.parse(document.location.pathname + document.location.search);
            //log all requests that were bypassed / not matched
            crossroads.bypassed.add(console.log, console);
            //after load the first route, set a flag with the idea that client control the navigation
            Router.ServerContentLoaded = false;
        });
    };
    Router.clickHandler = function (e) {
        var $element = $(e.target);
        var urlPath = $element.attr("href");
        if (urlPath != undefined && urlPath.length > 0) {
            e.preventDefault();
            if (location.hash.length > 0) {
                var hashUrl = urlPath.replace(window.BaseUrlWithVersions + "/", "");
                History.pushState({}, hashUrl, hashUrl);
                return;
            }
            History.pushState({}, urlPath, urlPath);
        }
    };
    Router.commonInit = function (insightsCustomProperties) {
        window.globalInsightsCustomProperties = insightsCustomProperties;
        $(".page").hide();
        //remove zoomImagContainer
        $('img.zoomed').removeData('elevateZoom'); //remove zoom instance from image
        $('.zoomWrapper img.zoomed').unwrap();
        $('.zoomContainer').remove();
    };
    Router.clearQueryString = function () {
    };
    Router.ServerContentLoaded = true;
    return Router;
}());
exports.Router = Router;
;
